export default "__VITE_ASSET__8f5ce6ab__"